import { createArticle, editArticle } from 'http/articleApi';
import { getAllArticleCategories } from 'http/articleCategoryApi';

import { DefaultOptionType } from 'antd/es/select';
import { IArticleCategory, ICreateArticle } from 'common/types';
import { notify } from 'common/utils';
import { computed, makeAutoObservable, observable } from 'mobx';
import { ArticleModel } from 'store/article-model';

export class ArticleControllerViewModel {
  _article: ArticleModel;
  _categoryOptions: DefaultOptionType[] = [];
  _loading = false;

  get article() {
    return this._article;
  }

  get loading() {
    return this._loading || this._article.loading;
  }

  set loading(loading: boolean) {
    this._loading = loading;
  }

  get categoryOptions() {
    return this._categoryOptions;
  }

  fetchCategoryOptions = async () => {
    console.log('aa?');
    this._loading = true;

    try {
      const categories = await getAllArticleCategories();

      this._categoryOptions = categories.map(
        (articleCategory: IArticleCategory) => ({
          value: articleCategory.id,
          label: articleCategory.name,
        }),
      );
    } catch (e) {
      notify(`Error, reason:${e}`, 'error');
    } finally {
      this._loading = false;
    }
  };

  manageArticle = async (isUpdate: boolean, values: ICreateArticle) => {
    this.loading = true;

    delete values.slug;

    try {
      if (isUpdate) {
        await editArticle(this.article.id, values);
      } else {
        await createArticle(values);
      }

      notify(
        <div>
          Article <strong>{values.title}</strong> was{' '}
          {isUpdate ? 'updated' : 'created'} succesfully!
        </div>,
      );

      return true;
    } catch (e) {
      notify(`Failed to ${isUpdate ? 'update' : 'create'} article`, 'error');
    } finally {
      this.loading = false;
    }
  };

  constructor(id: number) {
    this.fetchCategoryOptions();

    this._article = new ArticleModel(id);

    makeAutoObservable(this, {
      _loading: observable,
      article: computed,
      categoryOptions: computed,
    });
  }
}
